import classNames from 'classnames';
import React from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { COLORS } from '../../../../constants/styles';
import Icon from '../../../Icon';
import Card from '../../../Card';
import styles from './index.styl';

const insertActiveMarker = () => {
  const style = {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: COLORS.bluePrimary,
    marginBottom: '4px',
  };

  return <div style={style} />;
};

function SimpleMenuItem({
  active,
  icon,
  onClick,
  text,
  danger,
  borderTop,
  id,
  iconSize,
}) {
  const iconElement = icon ? (
    <Icon
      className="db mb1"
      name={icon}
      size={iconSize}
      style={{ fill: COLORS.bluePrimary }}
    />
  ) : null;

  const element = (
    <Card
      text={{ primary: text }}
      additionalContent={{
        left: iconElement,
        right: active ? insertActiveMarker() : null,
      }}
    />
  );

  return (
    <div
      id={id}
      styleName={classNames('menu-item', {
        'menu-item--danger': danger,
        'menu-item--border-top': borderTop,
      })}
      onClick={onClick}
    >
      {element}
    </div>
  );
}

SimpleMenuItem.propTypes = {
  active: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  danger: PropTypes.bool,
  borderTop: PropTypes.bool,
  iconSize: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CSSModules(SimpleMenuItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/IconMenu/MenuItem/SimpleItem.jsx